import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import * as constants from '../_model/string_literal';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {
  equipList = [];
  manufacturerList = [];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  getAllEquip() {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/equipment', this.httpOptionsAuth);
  }

  getAllManufacturer() {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/manufacturer', this.httpOptionsAuth);
  }

  getEquipModelById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/equipmentmodel?Id=' + id, this.httpOptionsAuth);
  }

  getEquipById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/equipment?Id=' + id, this.httpOptionsAuth);
  }

  getProductModelById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/productmodel?Id=' + id, this.httpOptionsAuth);
  }

  getProductById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/product?Id=' + id, this.httpOptionsAuth);
  }

  getCategoryById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/category?Id=' + id, this.httpOptionsAuth);
  }

  getManufacturerById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/manufacturer?Id=' + id, this.httpOptionsAuth);
  }

  getVesselEquipByVesselId(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/vesselequipment?VesselId=' + id, this.httpOptionsAuth);
  }

  getVesselEquipById(id: string) {
    return this.http.get(constants.IAPI_ENDPOINT + '/api/v1/equipment/vesselequipment?Id=' + id, this.httpOptionsAuth);
  }
}
